import { BypassCheckField } from "./bypass-check-field";

interface BypassSlotConflictFieldProps {
	checked: boolean;
	onCheckedChange: (value: boolean) => void;
	disabled?: boolean;
	/**
	 * Layout to match the sibling toggle on each page. See {@link BypassCheckField}.
	 */
	variant?: "inline" | "between";
}

/**
 * Admin-gated control to allow overlapping ("dempetan") therapist slots by
 * sending `bypass_slot_conflict` to the backend. Thin wrapper around the generic
 * {@link BypassCheckField} bound to the `bypass_slot_conflict` i18n copy.
 */
export function BypassSlotConflictField(props: BypassSlotConflictFieldProps) {
	return (
		<BypassCheckField
			id="bypass-slot-conflict"
			keyPrefix="bypass_slot_conflict"
			{...props}
		/>
	);
}
